import React from 'react';
import './PromptSuggestion.css';
import greenYes from '../../assets/greenYes.svg';
import redNo from '../../assets/redNo.svg';
import { useTranslation } from 'react-i18next';



const PromptSuggestion = ({ message, onSelect, onDismiss }) => {
  const { t } = useTranslation();
  
  if (message.selected || message.dismissed) return null;
  
  return (
    <div className="mt-6 promptPnc">
      <div className="flex justify-between items-center mb-2">
        <div className="flex items-center">
          <span className="font-medium text-gray-700">{t('promptSuggest')} </span>
          <span className="text-yellow-500 mr-2">✨</span>
        </div>
      </div>
      <div className="flex border border-yellow-300 border-dashed rounded-lg p-2 bg-yellow-50 relative promptSuggestionPnc">
        <div className='sugg1'><p className="text-gray-800 questionPartPnc"><span>{message.suggestion}</span> </p></div> 
        <div className="absolute flex space-x-1 gap-[8px] selectOptionYN sugg2">
            <img className='selectBtnPnc' src= {greenYes} alt="Yes Button"  onClick={() => onSelect(message.suggestion, message.messageId)}  />
            <img src= {redNo} alt="Yes Button" onClick={() => onDismiss(message.messageId)} />
        </div>
      </div>
    </div>
  );
};

export default PromptSuggestion;